<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Abstract'
}
</script>

<template lang="pug">
.route-view.route_view__base
  router-view(name="header")
  router-view(name="content")
  router-view(name="navigation")
</template>
